import React, { ReactElement } from 'react';

export interface QueryRouteProps {
  children: ReactElement;
  query?: string;
}

export const QueryRoute = ({ children }: QueryRouteProps) => children;
